import { useMutation } from 'react-query';

import { resetConfigOfSingleChecker as mutationFn } from 'api/endPoints/resetConfigOfSingleChecker';

export const useMutationResetConfigParams = () => {
    return useMutation<any, QueryError, IResetConfigParams>('resetConfigParams', (params) => mutationFn(params));
};

interface IResetConfigParams {
    configId: number;
    metaDataId: number;
}
